import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './style/index.css';

const SummaryPanel = (props) => {
  const { exceptions, allSamples } = props.data;

  const AllSamples = (
    <section className="summary-panel__section">
      <h2 className="summary-panel__section__title">{allSamples.title}</h2>
      <hr className="summary-panel__hr" />
      <ul className="summary-panel__section__list">
        {
          allSamples.children.map(test => (
            <li key={test.title}>
              <strong>{test.title}</strong>
              {test.children.map(child => <div key={child}>{child}</div>)}
            </li>
          ))
        }
      </ul>
    </section>
  );

  const Exceptions = (
    <section className="summary-panel__section">
      <h2 className="summary-panel__section__title">{exceptions.title}</h2>
      {
        exceptions.children.map((exception, i) => (
          <Fragment
            key={i} //eslint-disable-line
          >
            <hr className="summary-panel__hr" />
            <div className="summary-panel__section__subtitle">{exception.title}</div>
            <ul className="summary-panel__section__list">
              {
                exception.children.map((test, index) => (
                  <li
                    key={index} //eslint-disable-line
                  >
                    <strong>{test.title}</strong>
                    { test.children.map(child => <div>{child}</div>)}
                  </li>
                  ))
              }
            </ul>
          </Fragment>
        ))
      }
    </section>
  );

  return (
    <div className="summary-panel">
      {AllSamples}
      <hr className="summary-panel__hr--green" />
      {Exceptions}
    </div>
  );
};

SummaryPanel.propTypes = {
  data: PropTypes.shape({}),
};

export default SummaryPanel;



// WEBPACK FOOTER //
// ./src/components/SummaryPanel/SummaryPanel.jsx